module.exports = __webpack_public_path__ + "img/VU.fc5e6e09.svg";